
import { PricePoliciesApiRemoteService } from '../../Services/api/price-policies/price-policies-service'
import { ICreatePricePoliciesPayload, IPricePoliciesEntity } from '../../Services/api/price-policies/price-policies.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class CreatePricePoliciesUseCase
implements IFormUsecase<ICreatePricePoliciesPayload, IPricePoliciesEntity> {
  constructor (private readonly PricePoliciesApi: PricePoliciesApiRemoteService) {}
    
  public async handle (
    data: ICreatePricePoliciesPayload
  ): Promise<Result<IPricePoliciesEntity>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.PricePoliciesApi.create(data)

      const pricePolicies = response.getValue()
    
      return Result.ok(pricePolicies as IPricePoliciesEntity)
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
